module.exports = __webpack_public_path__ + "8d5571332fe02f449ed3be827d1431b2.pdf";